"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectUserStats = exports.Project = exports.ProjectStats = exports.EntityDoc = exports.AttributeDoc = exports.UserPropertyValue = exports.UserProperty = exports.UserPropertyKind = exports.UserPropertyName = exports.Tag = exports.TagName = exports.Layout = exports.LayoutItem = exports.Source = exports.LayoutName = exports.SourceKind = exports.SourceName = exports.SourceId = exports.ProjectName = exports.ProjectSlug = exports.ProjectId = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const database_1 = require("./database");
// FIXME: Work In Progress
// read this file from bottom to the top, to have a top-down read ^^
exports.ProjectId = common_1.Uuid;
exports.ProjectSlug = zod_1.z.string();
exports.ProjectName = zod_1.z.string();
exports.SourceId = common_1.Uuid;
exports.SourceName = zod_1.z.string();
exports.SourceKind = zod_1.z.enum(['Connection', 'SQL', 'AML', 'DBML', 'Prisma', 'JSON']);
exports.LayoutName = zod_1.z.string();
// SourceAttribute: firstSeen
// SourceEntity: firstSeen
exports.Source = zod_1.z.object({
    id: exports.SourceId,
    name: exports.SourceName,
    kind: exports.SourceKind,
    engine: database_1.DatabaseKind.optional(),
    url: zod_1.z.string().optional(), // db url, file url or file path
    database: database_1.Database,
    content: zod_1.z.string().optional(),
    inferredRelations: database_1.Relation.array().optional(),
    ignoredRelations: database_1.Relation.array().optional(),
    addedRelations: database_1.Relation.array().optional(),
    namespaceMappings: zod_1.z.record(database_1.NamespaceId, database_1.NamespaceId).optional(), // change namespaces when merging sources together
    enabled: zod_1.z.boolean().optional(), // TODO: move to layout
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
}).strict();
/*
 * Layout part
 */
// entity, row, note...
exports.LayoutItem = zod_1.z.object({});
exports.Layout = zod_1.z.object({
    name: exports.LayoutName,
    items: exports.LayoutItem.array(),
    itemSeq: zod_1.z.number().optional()
    // groups
}).strict();
/*
 * Documentation part
 */
exports.TagName = zod_1.z.string();
exports.Tag = zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    color: common_1.Color
}).strict();
// user properties allows to fill structured documentation, for example: ownership, lineage, data quality, expiration, link to resources...
exports.UserPropertyName = zod_1.z.string();
exports.UserPropertyKind = zod_1.z.enum([
    'string', // single line text
    'text', // multiline text, formatted with markdown
    'enum', // pre-defined set of values
    'url',
    'email',
    'phone',
    'date',
    'bool', // checkbox
    'number',
    'rating', // 5 stars rating
    'progress', // 0-100% progress bar
    'user', // user uuid
    'entity', // entity ref
    'attribute', // attribute ref
    'row' // row ref (table with primary key)
]);
exports.UserProperty = zod_1.z.object({
    name: exports.UserPropertyName,
    description: zod_1.z.string().optional(),
    // icon: z.enum(['???']).optional(),
    kind: exports.UserPropertyKind,
    on: zod_1.z.enum(['entity', 'attribute']).array(),
    multi: zod_1.z.boolean().optional(),
    enum_values: zod_1.z.object({
        name: zod_1.z.string(),
        description: zod_1.z.string().optional(),
        color: common_1.Color
    }).strict().array().optional(),
    string_values: zod_1.z.string().array().optional(),
    validation_regex: zod_1.z.string().optional()
}).strict();
exports.UserPropertyValue = zod_1.z.union([zod_1.z.string(), zod_1.z.string().array()]);
exports.AttributeDoc = zod_1.z.object({
    defaultShow: zod_1.z.boolean().optional(), // true when not specified
    defaultPos: zod_1.z.number().optional(),
    alias: zod_1.z.string().optional(),
    doc: common_1.Markdown.optional(),
    tags: exports.TagName.array().optional(),
    props: zod_1.z.record(exports.UserPropertyName, exports.UserPropertyValue).optional()
}).strict();
exports.EntityDoc = zod_1.z.object({
    alias: zod_1.z.string().optional(),
    doc: common_1.Markdown.optional(),
    tags: exports.TagName.array().optional(),
    props: zod_1.z.record(exports.UserPropertyName, exports.UserPropertyValue).optional(),
    attrs: zod_1.z.record(database_1.AttributePathId, exports.AttributeDoc).optional(),
}).strict();
exports.ProjectStats = zod_1.z.object({
    shownEntities: zod_1.z.record(database_1.EntityId, zod_1.z.number()).optional(), // get rough idea of entity popularity
    shownLayouts: zod_1.z.record(exports.LayoutName, zod_1.z.number()).optional(), // get rough idea of layout popularity
}).strict();
exports.Project = zod_1.z.object({
    id: exports.ProjectId,
    slug: exports.ProjectSlug,
    name: exports.ProjectName,
    // storage
    // version
    sources: exports.Source.array(),
    layouts: zod_1.z.record(exports.LayoutName, exports.Layout.array()),
    metadata: zod_1.z.record(database_1.EntityId, exports.EntityDoc).optional(),
    // queries
    stats: exports.ProjectStats.optional(),
    // createdAt
    // updatedAt
}).strict();
// stored only in the user browser
exports.ProjectUserStats = zod_1.z.object({
    shownEntities: zod_1.z.record(database_1.EntityId, zod_1.z.number()).optional(),
    shownLayouts: zod_1.z.record(exports.LayoutName, zod_1.z.number()).optional(),
    queryHistory: zod_1.z.object({
        source: exports.SourceId,
        query: zod_1.z.string(),
        ranAt: zod_1.z.date(),
    }).array().optional(),
}).strict();
//# sourceMappingURL=project.js.map